import { render, staticRenderFns } from "./ContentDiscoveryMenuBuilder.vue?vue&type=template&id=5bb4140a&"
import script from "./ContentDiscoveryMenuBuilder.vue?vue&type=script&lang=js&"
export * from "./ContentDiscoveryMenuBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports